window[`ga-disable-${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`] = true;

window.dataLayer = window.dataLayer || [];
window.gtag = function() { window.dataLayer.push(arguments); }

window.gtag('consent', 'default', {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 3000
});
window.gtag('event', 'default_consent');


import { enableAnalytics } from "./services/firebase-config.js";

// ① Attach it to window
window.enableAnalytics = enableAnalytics;
console.log("[Init] window.enableAnalytics =", window.enableAnalytics);

import React from "react";
import ReactDOM from "react-dom/client";
import * as klaro from "klaro";
import "./klaro-custom.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeContextProvider from "./theme/ThemeContext";

fetch("/klaro-config.json")
  .then((res) => {
    console.log("[Klaro] Fetch response status:", res.status);
    return res.json();
  })
  .then((config) => {
    console.log("[Klaro] Loaded config:", config);

    klaro.setup(config, {
      callback: (consents, serviceName) => {
        console.log("[Klaro callback fired]");
        console.log("Service name:", serviceName);
        console.log("Consents:", consents);

        if (consents.ga) {
          console.log("[Klaro] GA consent detected → enableAnalytics()");
          window.enableAnalytics().then(() => {
            console.log("[Analytics] enableAnalytics() completed");
          });
        }
      },
    });

    console.log("[Klaro] Forcing banner/modal via klaro.show()");
  })
  .catch((err) => {
    console.error("[Klaro] Error loading config:", err);
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
